const getShareAgreementStatus = (selectedReferralIds, referralId, specificAgreement, stateShareAgreement) => {
  const referralSelected = selectedReferralIds.includes(referralId);
  const specificAgreementAccepted = specificAgreement.status === 'accepted';
  const specificAgreementPending = specificAgreement.status === 'pending';
  const stateShareAgreementAccepted = stateShareAgreement.status === 'accepted';

  if (referralSelected && specificAgreementPending) {
    return 'pending';
  }

  const status = (referralSelected && specificAgreementAccepted && stateShareAgreementAccepted) ?
    'accepted' :
    'declined';

  return status;
};

const buildReferralConsents = (
  referralIds,
  agreementAnswer,
  consentMethod,
  submissionMethod,
  checkSpecificAgreement = false,
  specificAgreement,
) => referralIds.map((referralId) => ({
  state: checkSpecificAgreement ?
    getShareAgreementStatus(referralIds, referralId, specificAgreement, agreementAnswer) :
    agreementAnswer.status,
  consent_method: consentMethod,
  submission_method: submissionMethod,
  custom_consent_agreement: agreementAnswer.id,
  referral: referralId,
}));

const generateCustomConsentBatchBody = ({
  selectedReferralIds,
  unselectedReferralIds,
  communicationId,
  consentMethod,
  submissionMethod,
  specificAgreement,
  stateShareAgreement,
}) => {
  const consents = [
    ...buildReferralConsents(selectedReferralIds, specificAgreement, consentMethod, submissionMethod),
    ...buildReferralConsents(
      selectedReferralIds,
      stateShareAgreement,
      consentMethod,
      submissionMethod,
      true,
      specificAgreement,
    ),
    ...buildReferralConsents(
      unselectedReferralIds,
      { id: specificAgreement.id, status: 'declined' },
      consentMethod,
      submissionMethod,
    ),
    ...buildReferralConsents(
      unselectedReferralIds,
      { id: stateShareAgreement.id, status: 'declined' },
      consentMethod,
      submissionMethod,
    ),
  ];

  return communicationId ? {
    communication: communicationId,
    consents,
  } : { consents };
};

export default generateCustomConsentBatchBody;
